module.exports = __webpack_public_path__ + "img/page.1aa7fa6f.png";